import { Text, useColorMode } from "@chakra-ui/react";

export const ThemedText = (props) => {
  const { colorMode } = useColorMode();
  const textColor = colorMode === "dark" ? "gray.700" : "gray.500";

  return <Text {...props} color={textColor} />;
};
